import $ from "jquery";
import "./modelViewer.scss";
import * as THREE from "three";
import modelViewerHTML from "./modelViewer.html";
import { shareArComponent } from "../shareAr/shareAr";
import { GetGroup, OpenARorQR, WriteURLParameters, GetURLWithParameters } from "../../core/3d-configurator";
import { getMobileOperatingSystem } from "../../core/3d-scene";

export async function modelViewerComponent(container) {
  const componentContent = $('<div class="model-viewer-container"></div>');

  componentContent.append(modelViewerHTML);

  componentContent.find("#js-showModalShare").on("click", () => {
    $("#share").show();

    setTimeout(() => {
      if (typeof WriteURLParameters === 'function') {
        WriteURLParameters();
      }

      const shareUrl = window.location.href;
      console.log('Share URL:', shareUrl);
      const inputElement = $("#share").find('input[type="text"]').first();

      if (inputElement.length) {
        inputElement.val(shareUrl);
      } else {
        console.error('Input not found');
      }
    }, 150);
  });

  componentContent.find("#js-showModalQRcode").on("click", () => {
    OpenARorQR();

    if (
      getMobileOperatingSystem() == "Android" ||
      getMobileOperatingSystem() == "iOS"
    ) {
      GetGroup("shades_X").children.forEach((child) => {
        if (child.material) {
          child.material.side = THREE.DoubleSide;
        }
      });

      GetGroup("shades_Y").children.forEach((child) => {
        if (child.material) {
          child.material.side = THREE.DoubleSide;
        }
      });

      $("#footer").removeClass("footer-h");
    }
  });

  componentContent.find(".full-screen").on("click", () => {
    if ($("#interface").is(":visible")) {
      $("#interface").hide();
    } else {
      $("#interface").show();
    }
  });

  $(container).append(componentContent);
}
